import Bb from '../../../config/backbone'
import dispatcher from '../../../dispatcher'

const Player = Bb.Model.extend({
  defaults:{
    name:'',
    image:''
  },
  initialize(){
    Bb.Model.prototype.initialize.apply(this, arguments)
    this.listenTo(this, 'change', ()=>{ dispatcher.emit('playersHistory:changed')})
  }
})

const PlayersHistory = Bb.Collection.extend({
  model: Player,
  initialize(){
    Bb.Collection.prototype.initialize.apply(this, arguments)
    this.listenTo(this, 'remove add', ()=>{ dispatcher.emit('playersHistory:changed')})
  }
})


export default PlayersHistory







// WEBPACK FOOTER //
// ./src/game/players/collection/PlayersHistory.js